module.exports = __webpack_public_path__ + "img/5.4e9352fb.png";